import React, { useEffect, useState, useRef } from 'react';
import { HighlightText } from './HighlightText.jsx';
import { htmlToText } from '../../../utils/htmlText.js';

export const ExpandableDescription = ({ description, filters }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);

    // Feed Sources (RemoteOK, Working Nomads, …) deliver the body as raw HTML;
    // strip it to readable text so tags don't render literally. Plain-text
    // descriptions (Upwork) pass through unchanged.
    const formattedDescription = htmlToText(description);

    useEffect(() => {
        if (textRef.current && !isExpanded) {
            setIsOverflowing(textRef.current.scrollHeight > textRef.current.clientHeight);
        }
    }, [formattedDescription, filters, isExpanded]);

    if (!formattedDescription) return null;

    return (
        <div className="text-sm text-gray-600 mb-6 leading-relaxed whitespace-pre-wrap break-words">
            <div
                ref={textRef}
                className={`${!isExpanded ? 'line-clamp-5' : ''}`}
            >
                <HighlightText text={formattedDescription} filters={filters} />
            </div>

            {(isExpanded || isOverflowing) && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsExpanded(!isExpanded);
                    }}
                    className="text-blue-600 hover:text-blue-800 text-sm font-medium mt-1 focus:outline-none hover:underline flex items-center gap-1"
                >
                    {isExpanded ? 'Show less' : 'Show more'}
                </button>
            )}
        </div>
    );
};
